import { createAction } from '@reduxjs/toolkit';
import type {
  CreateQuizTemplatePayload,
  EditQuizPayload,
  EditQuizTemplatePayload,
  LaunchedQuizPayload,
  Quiz,
  QuizAnswerPayload,
  QuizPayload,
  QuizTemplate,
} from 'features/quizzes/types';
import type { EntityIdPayload, SignalingEventPayload } from 'services/signaling';

export const createQuizRequested = createAction<QuizPayload>('quizzes/createQuizRequested');

export const signalingQuizCreated = createAction<Quiz>('signaling/quiz/created');

export const launchQuizRequested = createAction<string>('quizzes/launchQuizRequested');
export const signalingQuizLaunched =
  createAction<
    SignalingEventPayload<LaunchedQuizPayload | { id: string; totalSecondsRemaining: number }>
  >('signaling/quiz/launched');

export const endQuizRequested = createAction<string>('quizzes/endQuizRequested');
export const signalingQuizEnded =
  createAction<SignalingEventPayload<EntityIdPayload>>('signaling/quiz/ended');

export const finishQuizRequested = createAction<QuizAnswerPayload>('quizzes/finishQuizRequested');
export const signalingQuizFinished = createAction<EntityIdPayload>('signaling/quiz/finished');

export const signalingQuizzesReceived = createAction<{
  quizzes: Quiz[];
}>('signaling/quiz/received');

export const deleteQuizRequested = createAction<string>('quizzes/deleteQuizRequested');
export const signalingQuizDeleted = createAction<EntityIdPayload>('signaling/quiz/deleted');

export const editQuizRequested = createAction<EditQuizPayload>('quizzes/editQuizRequested');
export const signalingQuizEdited = createAction<Quiz>('signaling/quiz/edited');

export const cloneQuizRequested = createAction<string>('quizzes/cloneQuizRequested');

export const exportSingleQuizRequested = createAction<string>('quizzes/exportSingleQuizRequested');

export const downloadQuizTemplateRequested = createAction('quizzes/downloadQuizTemplateRequested');

export const quizzesContentCleared = createAction<{ canManagePolls: boolean }>(
  'quizzes/contentCleared'
);

export const signalingQuizTemplatesReceived = createAction<{ templates: QuizTemplate[] }>(
  'signaling/quiz/templatesReceived'
);

export const signalingQuizTemplateCreated = createAction<QuizTemplate>(
  'signaling/quiz/templateCreated'
);

export const signalingQuizTemplateEdited = createAction<QuizTemplate>(
  'signaling/quiz/templateEdited'
);

export const signalingQuizTemplateDeleted = createAction<EntityIdPayload>(
  'signaling/quiz/templateDeleted'
);

export const createQuizTemplateRequested = createAction<CreateQuizTemplatePayload>(
  'quizzes/createTemplateRequested'
);

export const editQuizTemplateRequested = createAction<EditQuizTemplatePayload>(
  'quizzes/editTemplateRequested'
);

export const deleteQuizTemplateRequested = createAction<EntityIdPayload>(
  'quizzes/deleteTemplateRequested'
);

export const addQuizToRoomFromTemplateRequested = createAction<EntityIdPayload>(
  'quizzes/addToRoomFromTemplateRequested'
);

export const importQuizCsvRequested = createAction<File>('quizzes/importQuizCsvRequested');

export const importQuizTemplateCsvRequested = createAction<File>(
  'quizzes/importQuizTemplateCsvRequested'
);
